/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Image from '../partials/Image';

import styles from '../../../styles/cards/image.module.css';

const propTypes = {
    item: PropTypes.shape({}),
    roles: PropTypes.arrayOf(PropTypes.shape({})),
    className: PropTypes.string,
};

function ImageCard({ item = null, className = null, ...props }) {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            {...props}
        >
            <Image className={styles.image} image={item} size="medium" filtered rounded />
        </div>
    );
}

ImageCard.propTypes = propTypes;

export default ImageCard;
